"use strict";

const game_version = "v0.5.1.10";

function get_game_version() {
    return game_version;
}

export { game_version, get_game_version }